module.exports = "/fonts/fa-solid-900.svg?74404991700548b9b40251688ecfb210";